import { useMsal } from "@azure/msal-react";
import { appConfig } from "@/config/app";

export interface CurrentUser {
  userId: string;
  userEmail: string;
  roles: string[];
}

// Granted every role so local work isn't gated on Azure AD provisioning.
const DEV_USER: CurrentUser = {
  userId: "dev-bypass-user",
  userEmail: "dev-bypass@klyra.local",
  roles: ["ManualCleanse.Edit"],
};

// Returns null if MSAL is configured but no account is signed in yet -- the
// AuthGate normally prevents that path; callers must still guard edits.
export function useCurrentUser(): CurrentUser | null {
  const { accounts } = useMsal();

  if (appConfig.flags.devAuthBypass) {
    return DEV_USER;
  }

  const account = accounts[0];
  if (!account) return null;

  const rawRoles = account.idTokenClaims?.roles;
  const roles = Array.isArray(rawRoles)
    ? rawRoles.filter((r): r is string => typeof r === "string")
    : [];

  return {
    userId: account.localAccountId || account.homeAccountId,
    userEmail: account.username,
    roles,
  };
}
